import _ from "lodash";
import api from "@/api/cloud";
import config from "@/../public/config.json";


const state = () => ({
	items: [],
	current: null,
	resident: null,
});

const getters = {
	items: state => state.items || [],
	current: state => state.current,
	resident: state => state.resident,
	personalDevices: state =>
		_.get(state.resident, "Associations", [])
			.filter(({ type }) =>
				config.personalDeviceTypes.includes(type)
			),
};

const mutations = {
	SET_ITEMS(state, items) {
		state.items = items;
	},

	SET_CURRENT(state, current) {
		state.current = current;
	},

	SET_RESIDENT(state, resident) {
		state.resident = resident;
	},

	ADD_ASSOC(state, association) {
		state.resident.Associations.push(association);
	},

	RMV_ASSOC(state, id) {
		state.resident.Associations = state.resident.Associations.filter(item => item.id !== id);
	}
};

const actions = {
	async getItems({ commit, getters }, refresh = false) {
		let items = getters.items;
		if (!items.length || refresh) {
			items = await api.getRoomMoveTickets();
			items = items.map(item => ({ ...item, ...parseDescription(item.Description) }));
			commit("SET_ITEMS", items);
		}
		return items;
	},

	async getResident({ commit }, id) {
		const users = await api.getRoomMoveTicket(id);
		commit("SET_RESIDENT", users[0]);
		return users[0];
	},

	async addPersonalDevice({ getters, commit }, { identifier, name, type } = {}) {
		let association;

		try {
			association = await api.findAssociationByIdentifier(identifier);
		} catch (e) {
			if (e.response.status !== 404) throw e;
		}

		if (!association) {
			association = await api.addAssociation({ identifier, name, type });
		}

		const resp = await api.addAssociationUser(getters.resident.guid, association.id);
		commit("ADD_ASSOC", association);
		return resp;
	},

	async updatePersonalDevice({ __ }, { id, identifier, name } = {}) {
		return api.updateAssociation(id, { identifier, name });
	},

	async removePersonalDevice({ getters, commit }, { id }) {
		const resp = await api.removeAssociationUser(getters.resident.guid, id);
		commit("RMV_ASSOC", id);
		return resp;
	},

	async closeTicket({ getters, commit }) {
		const resident = _.cloneDeep(getters.resident);
		const resp = await api.removeUserProperty(resident.guid, "UserCreationTicket");
		resident.properties.UserCreationTicket = "";
		commit("SET_RESIDENT", resident);
		return resp;
	},

	async "close-New Resident"({ dispatch }, data) {
		return dispatch("addSystemToResident", data);
	},

	async "close-Move"({ dispatch }, data) {
		await dispatch("removeSystemFromResident", data);
		return dispatch("addSystemToResident", data);
	},

	async "close-Move Out"({ dispatch }, data) {
		await dispatch("removeSystemFromResident", data);
		return dispatch("removeUserRoomProps");
	},

	async addSystemToResident({ getters }, { newSys }) {
		// Move/Move In
		if (!newSys) return;
		const assoc = await api.findAssociationByIdentifier(newSys.id);
		await api.addAssociationUser(getters.resident.guid, assoc.id);
		return api.addUserProperty(getters.resident.guid, "roomNumber", newSys.name);
	},

	async removeSystemFromResident({ getters }, { oldSys }) {
		// Move/Move Out
		if (!oldSys) return;
		const assoc = await api.findAssociationByIdentifier(oldSys.id);
		return api.removeAssociationUser(getters.resident.guid, assoc.id);
	},

	async removeUserRoomProps({ getters }) {
		// Move Out
		try {
			await api.removeUserProperty(getters.resident.guid, "roomNumber");
		} catch (e) {
			if (e.response.status !== 404) {
				throw e;
			}
		}
		await api.addUserProperty(getters.resident.guid, "status", "archived");
		return true;
	},
};

const parseDescription = (description) => {
	const [summary, ...details] = _.filter(description.split("\n").map(s => s.trim()));
	const [, resident, community, userName, userEmail] = summary.match(/.*for (.*) via (.*) co.*by (.*) (\S*@\S*)/) || [];

	return {
		resident, community, userName, userEmail, ...details.reduce((details, line) => {
			const [key, value] = line.split(": ");
			details[key] = value;
			return details;
		}, {})
	};
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};
